// this middleware is used for fetching content.json file from public/data/ 
// in future only this file will requird to change for API integration

export const getProducts = async () => {
  const response = await fetch("/data/products.json");

  if (!response.ok) {
    throw new Error("Failed to fetch Products");
  }

  return response.json();
};
